import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

export interface IUserWraperProps {}

export const userWrapper =
  (Component: FC<IUserWraperProps>) => (props: IUserWraperProps) => {
    return (
      <div className='withUserWraper'>
        <div className='TabLinks'>
          <NavLink
            to={Routes.userList.path}
            // isActive={() => {
            //   return props?.location?.pathname === '/' || props?.location?.pathname === Routes.userList.path;
            // }}
          >
            <Icon.User />
            User List
          </NavLink>

          {/* <NavLink to={Routes.userKYCList.path} >
                    <Icon.KYC />

                    KYC List
                </NavLink> */}
        </div>

        <Component {...props} />
      </div>
    );
  };
